/**
 * Translation labels
 */
 
const header = {
    cta: "Download our white paper"
}

const intro = {
    title: "Cyber security at SMEs",
    tagline: "Mission ‘peace of mind’"
}

const rapport = {
    title: "Discover brand new figures about how Belgian SMEs deal with cyber security.",
    faq: [{
        question: "How concerned are SMEs?",
        answer: "Locavore keffiyeh everyday carry, normcore fashion axe chillwave photo booth enamel pin messenger bag helvetica aesthetic. Squid health goth subway tile waistcoat. Chicharrones slow-carb gastropub twee next level tumeric. Shabby chic craft beer typewriter air plant trust fund vexillologist glossier sriracha bicycle rights brooklyn mustache taiyaki etsy. Pickled narwhal pinterest fam live-edge sustainable paleo. Tousled tofu locavore, offal chicharrones vexillologist portland actually. Tilde flexitarian tacos raw denim occupy, fanny pack fam viral single-origin coffee kogi vinyl palo santo church-key."
    }, {
        question: "How many and what attacks did they experience in 2019?",
        answer: "Food truck raw denim cred vaporware brooklyn, pabst hoodie hella enamel pin. Taiyaki squid sartorial, typewriter cronut shaman banjo yr photo booth hell of fanny pack. Mustache master cleanse PBR&B art party, church-key poke heirloom leggings. Humblebrag succulents chambray scenester. Seitan helvetica vexillologist pinterest hashtag photo booth, four dollar toast aesthetic. Try-hard affogato freegan mlkshk, selvage tumblr 90's vice drinking vinegar fashion axe ennui twee disrupt yuccie. Jean shorts chicharrones food truck +1."
    }, {
        question: "How do they protect themselves?",
        answer: "Vexillologist art party subway tile you probably haven't heard of them everyday carry squid, +1 post-ironic tumblr gluten-free whatever waistcoat mustache deep v. Stumptown sriracha shaman direct trade swag snackwave yuccie VHS single-origin coffee 90's before they sold out humblebrag. Post-ironic irony flexitarian, shoreditch wolf enamel pin pok pok. Woke street art air plant semiotics paleo truffaut jean shorts gochujang cornhole photo booth aesthetic tbh intelligentsia. Swag kinfolk twee, VHS ramps locavore iPhone selfies pug thundercats vinyl flannel before they sold out knausgaard. Kitsch edison bulb leggings umami. Heirloom craft beer vaporware mustache, dreamcatcher occupy semiotics tumblr cred."
    }, {
        question: "Determine your risk profile and prepare your peace of mind plan.",
        answer: "Squid listicle vegan cold-pressed glossier, cloud bread deep v DIY pug succulents vaporware tattooed twee. Hashtag everyday carry vexillologist before they sold out bushwick. Blue bottle locavore dreamcatcher la croix heirloom, synth stumptown messenger bag lyft butcher. Fam shoreditch celiac meditation pok pok. Scenester waistcoat four dollar toast helvetica chillwave mustache, stumptown hashtag ugh hexagon pug gluten-free tacos sriracha hammock. Schlitz lo-fi photo booth lumbersexual fixie truffaut knausgaard. Meditation bushwick neutra, hella adaptogen waistcoat lyft prism mumblecore truffaut tattooed jianbing."
    }]
}

const numbers = {
    title: "New figures",
    info: "In the last few months, Proximus has carried out a unique qualitative and quantitative investigation among 122 Belgian SMEs.",
    invader: {
        cta: "CLICK ME AND WIN...",
        reaction: "A SERVER INFECTED BY THOUSANDS OF VIRUSES"
    },
    cyberattacks: {
        title: "Preview: the most striking facts",
        total: {
            percentage: 56,
            description: "of SMEs in the Benelux experienced a cyber attack in 2019"
        },
        types: {
            title: "What kind of attacks was most common among Belgian SMEs?",
            data: [{
                percentage: 43,
                description: "(Spear)-Phishing"
            }, {
                percentage: 19,
                description: "Malware"
            }, {
                percentage: 11,
                description: "Password attack"
            }]
        }
    }
}

const quiz = {
    title: "Test yourself",
    questions: [{
        q: "How often was ransomware used in a malware attack against Belgian SMEs?",
        type: "single",
        answers: [{
            val: "23%",
            correct: false
        }, {
            val: "39%",
            correct: true
        }, {
            val: "43%",
            correct: false
        }]
    }, {
        q: "What do Belgian SMEs consider to be the 2 biggest threats to their cyber security?",
        note: "Tick 2 of the 4 bullets",
        type: "multiple",
        answers: [{
            val: "users",
            correct: true
        }, {
            val: "e-mail",
            correct: false
        }, {
            val: "mobile devices",
            correct: true
        }, {
            val: "social media",
            correct: false
        }]
    }, {
        q: "How much did the damage resulting from cyber attacks against Belgian SMEs increase in the insurance year 2018?",
        source: "source: Cyberstudie 2019 - Vanbreda Risk & Benefits",
        type: "single",
        answers: [{
            val: "49%",
            correct: false
        }, {
            val: "149%",
            correct: true
        }, {
            val: "99%",
            correct: false
        }]
    }],
    scoreValues: [
        "OMG, a nil-score: 0.00%!",
        "Failed, with a score of only 33.33%",
        "Huh, a  mediocre score of 66.66%",
        "Wow, a perfect score of 100%!"
    ]
}

const results = {
    title: "Find out about all the results of our qualitative and quantitative investigation into cyber security at Belgian SMEs.",
    faq: [{
        question: "How great is the risk of a cyber attack?",
        answer: "I'm baby live-edge vape tumblr, kitsch cred forage whatever vaporware kale chips ramps subway tile williamsburg glossier. Pour-over quinoa sartorial, narwhal keytar cred snackwave gluten-free tattooed tumeric four loko coloring book pinterest. Man bun la croix hoodie aesthetic. Tattooed live-edge vice cornhole. Austin shoreditch meh direct trade intelligentsia. Taiyaki narwhal pinterest, waistcoat glossier raclette bespoke art party whatever meggings thundercats street art af. Pug paleo truffaut edison bulb pok pok, retro helvetica tacos woke hot chicken."
    }, {
        question: "How do Belgian SMEs manage their security infrastructure?",
        answer: "Hashtag flannel roof party cliche brooklyn pork belly humblebrag crucifix PBR&B taiyaki. Cray vegan seitan, skateboard subway tile pour-over aesthetic etsy jianbing artisan master cleanse fanny pack. Chambray waistcoat humblebrag PBR&B single-origin coffee umami coloring book chartreuse, ennui beard direct trade blog master cleanse sartorial. Keytar letterpress raw denim gastropub taxidermy art party master cleanse. Irony listicle direct trade beard edison bulb. Flexitarian ennui yr brooklyn intelligentsia."
    }, {
        question: "What determines your risk profile and how do Proximus experts protect your company?",
        answer: "Small batch cardigan activated charcoal, slow-carb selfies raclette PBR&B cred disrupt quinoa bushwick locavore roof party deep v. Jianbing four dollar toast pug pabst taiyaki pork belly. Chia fashion axe forage enamel pin, street art neutra beard palo santo farm-to-table put a bird on it single-origin coffee migas. Sartorial tofu truffaut air plant narwhal pour-over, deep v XOXO la croix. Disrupt gluten-free everyday carry sriracha. Raw denim pug neutra fixie readymade fashion axe."
    }, {
        question: "And also: 25 terms that take your cyber security to a higher level",
        answer: "Letterpress hashtag jianbing blog polaroid kinfolk. Banh mi umami master cleanse, bitters kombucha microdosing yr flannel mixtape iceland kinfolk. Umami heirloom adaptogen vexillologist, mlkshk small batch blog. Iceland health goth hella mustache, wolf typewriter gastropub paleo irony vape woke. Tofu cloud bread selfies, air plant microdosing trust fund la croix fixie mixtape readymade viral slow-carb unicorn. Chillwave XOXO austin vice swag cold-pressed, pork belly lomo 3 wolf moon venmo. Tumblr knausgaard man bun, 8-bit crucifix paleo slow-carb normcore mustache occupy pug."
    }],
    cta: {
        text: "Download our white paper and protect your company",
        path: "https://www.enterprises.proximus.be/security_download_surveyreport2019_en"
    }
}

const labels = {
    header,
    intro,
    rapport,
    numbers,
    quiz,
    results
}

export default labels;